import { render, staticRenderFns } from "./ProvisionalOrderLossConfirmDialog.vue?vue&type=template&id=3b94e20f&lang=pug"
import script from "./ProvisionalOrderLossConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ProvisionalOrderLossConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports